'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { useClientNav } from '@susu/headless-commerce/features/navigation/components/ClientNavProvider'
import classNames from 'classnames'
import { type ReactNode, useCallback } from 'react'
import styles from './NavBack.module.scss'

export type ClientNavBackProps = {
  children: ReactNode
  className?: string
}

export const ClientNavBack = ({ children, className }: ClientNavBackProps) => {
  useSignals()

  const { closeSubMenu } = useClientNav()

  const handleBackButtonClick = useCallback(closeSubMenu, [])

  const backClass = classNames(styles['nav__back'], 'nav__back', className)
  const backButtonClass = classNames(styles['nav__back-btn'], className)

  return (
    <div className={backClass} data-testid="nav-back">
      <button
        className={backButtonClass}
        onClick={handleBackButtonClick}
        type="button"
      >
        {children}
      </button>
    </div>
  )
}
